import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from 'reactstrap';

const SoftErrorModal = ({ isOpen, toggle, title, body }) => (
    <Modal isOpen={isOpen} toggle={toggle} centered backdrop fade>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
            <Alert color="warning">
                <i className="bi bi-exclamation-octagon" /> {body}
            </Alert>
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={toggle}>Close</Button>
        </ModalFooter>
    </Modal>
);

export default SoftErrorModal;